export const SHOW_LOADING = 'GLOBAL_SHOW_LOADING';
export const HIDE_LOADING = 'GLOBAL_HIDE_LOADING';